let refreshPromise = null;

export function getAccessTokenExpiry(token) {
  if (!token || typeof token !== "string") {
    return null;
  }

  const parts = token.split(".");
  if (parts.length !== 3) {
    return null;
  }

  try {
    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const paddedPayload = payload.padEnd(
      payload.length + ((4 - (payload.length % 4)) % 4),
      "="
    );
    const decoded = JSON.parse(window.atob(paddedPayload));
    return Number.isFinite(decoded?.exp) ? decoded.exp * 1000 : null;
  } catch {
    return null;
  }
}

export function accessTokenNeedsRefresh(token, now = Date.now(), leadTimeMs = 90_000) {
  const expiry = getAccessTokenExpiry(token);
  return expiry !== null && expiry <= now + leadTimeMs;
}

export function refreshAccessTokenOnce(refreshAccessToken) {
  if (typeof refreshAccessToken !== "function") {
    return Promise.reject(new Error("Access-token refresh is unavailable."));
  }

  if (!refreshPromise) {
    refreshPromise = Promise.resolve()
      .then(() => refreshAccessToken())
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
}
